import _ from 'lodash';
import { apiRequestModes } from './../../../server/enums';

export function fetchApps(state, { page, sort, filter }) {
  return {
    ...state,
    apps: {
      ...state.apps,
      currentPage: page,
      sort: sort || state.apps.sort,
      filter: filter || state.apps.filter,
    },
  };
}

export function fetchAppsSuccess(state, { apps }) {
  return {
    ...state,
    apps: {
      ...state.apps,
      numberOfPages: apps.numberOfPages,
      count: apps.count,
      items: apps.items,
    },
  };
}

export function fetchAppsNames(state) {
  return {
    ...state,
    apps: {
      ...state.apps,
      names: [],
    },
  };
}

export function fetchAppsNamesSuccess(state, names) {
  return {
    ...state,
    apps: {
      ...state.apps,
      names,
    },
  };
}

export function openAddAppModal(state) {
  return {
    ...state,
    newApp: {
      formName: state.newApp.formName,
      showModal: true,
      isFetching: false,
      error: null,
      isFetchingSuccess: true,
    },
  };
}

export function closeAddAppModal(state) {
  return {
    ...state,
    newApp: {
      showModal: false,
      isFetching: false,
      error: null,
      isFetchingSuccess: true,
    },
  };
}

export function addApp(state) {
  return {
    ...state,
    newApp: {
      ...state.newApp,
      isFetching: true,
    },
  };
}

export function addAppSuccess(state, app) {
  return {
    ...state,
    apps: {
      ...state.apps,
      items: [
        app,
        ...state.apps.items,
      ],
    },
    newApp: {
      formName: state.newApp.formName,
      isFetching: false,
      showModal: false,
    },
  };
}

export function addAppFail(state) {
  return {
    ...state,
    newApp: {
      ...state.newApp,
      isFetching: false,
    },
  };
}

export function updateApp(state) {
  return {
    ...state,
    newApp: {
      ...state.newApp,
      isFetching: true,
    },
  };
}

export function updateAppSuccess(state, updatedApp) {
  let apps = state.apps;
  if (state.apps.items.length > 0) {
    const appIndex = state.apps.items.findIndex(x => x._id === updatedApp._id);
    apps = {
      ...state.apps,
      items: [
        ...state.apps.items.slice(0, appIndex),
        updatedApp,
        ...state.apps.items.slice(appIndex + 1),
      ],
    };
  }
  return {
    ...state,
    apps,
    app: updatedApp,
    newApp: {
      isFetching: false,
      showModal: false,
      error: null,
      isFetchingSuccess: true,
    },
  };
}

export function updateAppFail(state) {
  return {
    ...state,
    newApp: {
      ...state.newApp,
      isFetching: false,
    },
  };
}

export function parseAppFromUrl(state, url) {
  return {
    ...state,
    newApp: {
      ...state.newApp,
      url,
      isFetching: true,
    },
  };
}

export function parseAppFromUrlSuccess(state, newAppInfo) {
  return {
    ...state,
    newApp: {
      ...state.newApp,
      os: newAppInfo.type,
      ...newAppInfo,
      isFetching: false,
      appType: state.newApp.appType,
      isFetchingSuccess: newAppInfo && newAppInfo.image,
      error: null,
    },
  };
}

export function parseAppFromUrlFail(state, error) {
  return {
    ...state,
    newApp: {
      ...state.newApp,
      isFetching: false,
      error,
    },
  };
}

export function changeAppType(state, appType) {
  return {
    ...state,
    newApp: {
      showModal: true,
      isFetching: false,
      error: null,
      isFetchingSuccess: true,
      appType,
      formName: appType === 'mobile' ? 'addMobileApp' : 'addWebApp',
    },
  };
}

export function changeAppFormName(state, name) {
  return {
    ...state,
    newApp: {
      ...state.newApp,
      showModal: true,
      formName: name,
    },
  };
}

export function saveApp(state, app) {
  return {
    ...state,
    newApp: {
      ...app,
      ...state.newApp,
    },
  };
}

export function fetchAppDetailsSuccess(state, app) {
  let apps = state.apps;
  if (!apps || apps.length === 0) {
    apps = [app];
  }
  return {
    ...state,
    apps,
    app,
  };
}

export function updateUnitStatusSuccess(state, { appId, unitId, active }) {
  const unitIndex = state.app.adUnits.findIndex(x => x._id === unitId);
  const unit = state.app.adUnits.find(x => x._id === unitId);
  if (!unit) {
    return state;
  }

  let apps = state.apps;
  if (state.apps.items.length > 0) {
    const appIndex = state.apps.items.findIndex(x => x._id === appId);
    const app = state.apps.items.find(x => x._id === appId);
    apps = {
      ...state.apps,
      items: [
        ...state.apps.items.slice(0, appIndex),
        {
          ...app,
          adUnits: [
            ...app.adUnits.slice(0, unitIndex),
            {
              ...unit,
              active,
            },
            ...app.adUnits.slice(unitIndex + 1),
          ],
        },
        ...state.apps.items.slice(appIndex + 1),
      ],
    };
  }
  return {
    ...state,
    apps,
    app: {
      ...state.app,
      adUnits: [
        ...state.app.adUnits.slice(0, unitIndex),
        {
          ...unit,
          active,
        },
        ...state.app.adUnits.slice(unitIndex + 1),
      ],
    },
  };
}

export function openAddPlacement(state, { appId, unitId, placementId, placement, unitType }) {
  return {
    ...state,
    newPlacement: {
      showModal: true,
      appId,
      unitId,
      unitType,
      placementId,
      placement,
      isFetching: false,
    },
  };
}

export function closeAddPlacement(state) {
  return {
    ...state,
    newPlacement: {
      showModal: false,
    },
  };
}

export function openUpdatePostback(state, { appId, postback, unitId, unitType }) {
  return {
    ...state,
    postback: {
      showModal: true,
      appId,
      hash: state.account.id,
      secretKey: state.account.secretKey,
      unitId,
      postback,
      unitType,
    },
  };
}

export function closeUpdatePostback(state) {
  return {
    ...state,
    postback: {
      showModal: false,
    },
  };
}

export function openUpdateSurveyPromotion(state, { appId, unit, surveyPromotion }) {
  return {
    ...state,
    surveyPromotion: {
      showModal: true,
      appId,
      unit,
      surveyPromotion,
    },
  };
}

export function closeUpdateSurveyPromotion(state) {
  return {
    ...state,
    surveyPromotion: {
      showModal: false,
    },
  };
}

export function openAPIIntegration(state, { appId, unitId, placementId, unitType }) {
  const unit = state.app.adUnits.find(x => x._id === unitId);
  if (!unit) {
    return state;
  }
  const placement = unit.placements.find(x => x._id === placementId);
  if (!placement) {
    return state;
  }

  return {
    ...state,
    apiRequest: {
      showModal: true,
      appId,
      unitId,
      placementId,
      unitType,
      mode: _.get(placement, 'apiRequest.mode') || apiRequestModes.PENDING,
      key: _.get(placement, 'apiRequest.key'),
    },
  };
}

export function closeAPIIntegration(state) {
  return {
    ...state,
    apiRequest: {
      showModal: false,
    },
  };
}

export function openIFrame(state, { unitId, placementId }) {
  const unit = state.app.adUnits.find(x => x._id === unitId);
  if (!unit) {
    return state;
  }
  const placement = unit.placements.find(x => x._id === placementId);
  if (!placement) {
    return state;
  }

  return {
    ...state,
    iFrame: {
      showModal: true,
      placementId,
    },
  };
}

export function closeIFrame(state) {
  return {
    ...state,
    iFrame: {
      showModal: false,
    },
  };
}

export function openTestPostback(state, { appId, postback, unitId, accountId, accountSecretKey }) {
  return {
    ...state,
    postback: {
      appId,
      unitId,
      accountId,
      accountSecretKey,
      postback,
    },
  };
}

export function closeTestPostback(state) {
  return {
    ...state,
    postback: {
    },
  };
}


export function addPlacement(state) {
  return {
    ...state,
    newPlacement: {
      ...state.newPlacement,
      isFetching: true,
    },
  };
}

export function addPlacementSuccess(state, { appId, unitId, placement }) {
  const unitIndex = state.app.adUnits.findIndex(x => x._id === unitId);
  const unit = state.app.adUnits.find(x => x._id === unitId);
  if (!unit) {
    return state;
  }

  let apps = state.apps;
  if (state.apps.items.length > 0) {
    const appIndex = state.apps.items.findIndex(x => x._id === appId);
    const app = state.apps.items.find(x => x._id === appId);
    apps = {
      ...state.apps,
      items: [
        ...state.apps.items.slice(0, appIndex),
        {
          ...app,
          adUnits: [
            ...app.adUnits.slice(0, unitIndex),
            {
              ...unit,
              placements: [
                ...unit.placements,
                placement,
              ],
            },
            ...app.adUnits.slice(unitIndex + 1),
          ],
        },
        ...state.apps.items.slice(appIndex + 1),
      ],
    };
  }
  return {
    ...state,
    apps,
    app: {
      ...state.app,
      adUnits: [
        ...state.app.adUnits.slice(0, unitIndex),
        {
          ...unit,
          placements: [
            ...unit.placements,
            placement,
          ],
        },
        ...state.app.adUnits.slice(unitIndex + 1),
      ],
    },
  };
}

export function updatePlacement(state) {
  return {
    ...state,
    newPlacement: {
      ...state.newPlacement,
      isFetching: true,
    },
  };
}

export function updatePlacementSuccess(state,
  { appId, unitId, placementId, placement: placementData }) {
  const unitIndex = state.app.adUnits.findIndex(x => x._id === unitId);
  const unit = state.app.adUnits.find(x => x._id === unitId);
  if (!unit) {
    return state;
  }
  const placementIndex = unit.placements.findIndex(x => x._id === placementId);
  const placement = unit.placements.find(x => x._id === placementId);
  if (!placement) {
    return state;
  }

  let apps = state.apps;

  if (state.apps.items.length > 0) {
    const appIndex = state.apps.items.findIndex(x => x._id === appId);
    const app = state.apps.items.find(x => x._id === appId);
    apps = {
      ...state.apps,
      items: [
        ...state.apps.items.slice(0, appIndex),
        {
          ...app,
          adUnits: [
            ...app.adUnits.slice(0, unitIndex),
            {
              ...unit,
              placements: [
                ...unit.placements.slice(0, placementIndex),
                {
                  ...placement,
                  name: placementData.name,
                  currencyPluralName: placementData.currencyPluralName,
                  currencySingleName: placementData.currencySingleName,
                  supportsDecimal: placementData.supportsDecimal === 'yes',
                  currencyPerUsd: placementData.currencyRate,
                  capping: placementData.capping,
                  pacing: placementData.pacing,
                  limitation: placementData.limitation,
                  apiRequest: placementData.apiRequest,
                },
                ...unit.placements.slice(placementIndex + 1),
              ],
            },
            ...app.adUnits.slice(unitIndex + 1),
          ],
        },
        ...state.apps.items.slice(appIndex + 1),
      ],
    };
  }
  return {
    ...state,
    apps,
    app: {
      ...state.app,
      adUnits: [
        ...state.app.adUnits.slice(0, unitIndex),
        {
          ...unit,
          placements: [
            ...unit.placements.slice(0, placementIndex),
            {
              ...placement,
              name: placementData.name,
              currencyPluralName: placementData.currencyPluralName,
              currencySingleName: placementData.currencySingleName,
              supportsDecimal: placementData.supportsDecimal === 'yes',
              currencyPerUsd: placementData.currencyRate,
              capping: placementData.capping,
              pacing: placementData.pacing,
              limitation: placementData.limitation,
              apiRequest: placementData.apiRequest,
            },
            ...unit.placements.slice(placementIndex + 1),
          ],
        },
        ...state.app.adUnits.slice(unitIndex + 1),
      ],
    },
  };
}

export function deletePlacementSuccess(state,
  { appId, unitId, placementId }) {
  const unitIndex = state.app.adUnits.findIndex(x => x._id === unitId);
  const unit = state.app.adUnits.find(x => x._id === unitId);
  if (!unit) {
    return state;
  }
  const placementIndex = unit.placements.findIndex(x => x._id === placementId);
  const placement = unit.placements.find(x => x._id === placementId);
  if (!placement) {
    return state;
  }

  let apps = state.apps;
  if (state.apps.items.length > 0) {
    const appIndex = state.apps.items.findIndex(x => x._id === appId);
    const app = state.apps.items.find(x => x._id === appId);
    apps = {
      ...state.apps,
      items: [
        ...state.apps.items.slice(0, appIndex),
        {
          ...app,
          adUnits: [
            ...app.adUnits.slice(0, unitIndex),
            {
              ...unit,
              placements: [
                ...unit.placements.slice(0, placementIndex),
                ...unit.placements.slice(placementIndex + 1),
              ],
            },
            ...app.adUnits.slice(unitIndex + 1),
          ],
        },
        ...state.apps.items.slice(appIndex + 1),
      ],
    };
  }
  return {
    ...state,
    apps,
    app: {
      ...state.app,
      adUnits: [
        ...state.app.adUnits.slice(0, unitIndex),
        { ...unit,
          placements: [
            ...unit.placements.slice(0, placementIndex),
            ...unit.placements.slice(placementIndex + 1),
          ],
        },
        ...state.app.adUnits.slice(unitIndex + 1),
      ],
    },
  };
}

export function updatePlacementStatusSuccess(state,
  { appId, unitId, placementId, active }) {
  const unitIndex = state.app.adUnits.findIndex(x => x._id === unitId);
  const unit = state.app.adUnits.find(x => x._id === unitId);
  if (!unit) {
    return state;
  }
  const placementIndex = unit.placements.findIndex(x => x._id === placementId);
  const placement = unit.placements.find(x => x._id === placementId);
  if (!placement) {
    return state;
  }

  let apps = state.apps;
  if (state.apps.items.length > 0) {
    const appIndex = state.apps.items.findIndex(x => x._id === appId);
    const app = state.apps.items.find(x => x._id === appId);
    apps = {
      ...state.apps,
      items: [
        ...state.apps.items.slice(0, appIndex),
        {
          ...app,
          adUnits: [
            ...app.adUnits.slice(0, unitIndex),
            {
              ...unit,
              placements: [
                ...unit.placements.slice(0, placementIndex),
                {
                  ...placement,
                  active,
                },
                ...unit.placements.slice(placementIndex + 1),
              ],
            },
            ...app.adUnits.slice(unitIndex + 1),
          ],
        },
        ...state.apps.items.slice(appIndex + 1),
      ],
    };
  }
  return {
    ...state,
    apps,
    app: {
      ...state.app,
      adUnits: [
        ...state.app.adUnits.slice(0, unitIndex),
        {
          ...unit,
          placements: [
            ...unit.placements.slice(0, placementIndex),
            {
              ...placement,
              active,
            },
            ...unit.placements.slice(placementIndex + 1),
          ],
        },
        ...state.app.adUnits.slice(unitIndex + 1),
      ],
    },
  };
}

export function updatePostbackSuccess(state, { appId, postback, unitId }) {
  const unitIndex = state.app.adUnits.findIndex(x => x._id === unitId);
  const unit = state.app.adUnits.find(x => x._id === unitId);
  if (!unit) {
    return state;
  }

  let apps = state.apps;
  if (state.apps.items.length > 0) {
    const appIndex = state.apps.items.findIndex(x => x._id === appId);
    const app = state.apps.items.find(x => x._id === appId);
    apps = {
      ...state.apps,
      items: [
        ...state.apps.items.slice(0, appIndex),
        {
          ...app,
          adUnits: [
            ...app.adUnits.slice(0, unitIndex),
            {
              ...unit,
              postback,
            },
            ...app.adUnits.slice(unitIndex + 1),
          ],
        },
        ...state.apps.items.slice(appIndex + 1),
      ],
    };
  }
  return {
    ...state,
    apps,
    app: {
      ...state.app,
      adUnits: [
        ...state.app.adUnits.slice(0, unitIndex),
        {
          ...unit,
          postback,
        },
        ...state.app.adUnits.slice(unitIndex + 1),
      ],
    },
  };
}

export function updateSurveyPromotionSuccess(state, { appId, unitId, surveyPromotion }) {
  const app = state.apps.items.find(x => x._id === appId);
  const appIndex = state.apps.items.findIndex(x => x._id === appId);

  const unitIndex = app.adUnits.findIndex(x => x._id === unitId);
  const unit = app.adUnits.find(x => x._id === unitId);

  const apps = {
    ...state.apps,
    items: [
      ...state.apps.items.slice(0, appIndex),
      {
        ...app,
        adUnits: [
          ...app.adUnits.slice(0, unitIndex),
          {
            ...unit,
            surveyPromotion,
          },
          ...app.adUnits.slice(unitIndex + 1),
        ],
      },
      ...state.apps.items.slice(appIndex + 1),
    ],
  };

  return {
    ...state,
    apps,
    app: {
      ...state.app,
      adUnits: [
        ...state.app.adUnits.slice(0, unitIndex),
        {
          ...unit,
          surveyPromotion,
        },
        ...state.app.adUnits.slice(unitIndex + 1),
      ],
    },
    surveyPromotion: {
      showModal: false,
    },
  };
}

export function updateSurveyPromotionFail(state, error) {

}

export function openDefineNotLiveApp(state, { app }) {
  return {
    ...state,
    newApp: {
      ...app,
      showModal: true,
      isFetching: false,
      error: null,
      isFetchingSuccess: true,
    },
  };
}

export function closeDefineNotLiveApp(state) {
  return {
    ...state,
    newApp: {
      showModal: false,
      isFetching: false,
      error: null,
      isFetchingSuccess: true,
    },
  };
}

export function updatePlacementFromSocket(state, {
  appId, unitId, placementId, placement: placementData,
}) {
  const appIndex = state.apps.items.findIndex((item) => item._id === appId);
  if (appIndex === -1 && (!state.app || state.app._id !== appId)) {
    return state;
  }

  let app = state.apps.items[appIndex];
  const unitIndex = app.adUnits.findIndex((unit) => unit._id === unitId);
  if (unitIndex === -1) {
    return state;
  }
  const unit = app.adUnits[unitIndex];
  const placementIndex = unit.placements.findIndex((placement) => placement._id === placementId);
  if (placementIndex === -1) {
    return state;
  }
  const placement = unit.placements[placementIndex];
  app = {
    ...app,
    adUnits: [
      ...app.adUnits.slice(0, unitIndex),
      {
        ...unit,
        placements: [
          ...unit.placements.slice(0, placementIndex),
          {
            ...placement,
            name: placementData.name,
            currencyPluralName: placementData.currencyPluralName,
            currencySingleName: placementData.currencySingleName,
            supportsDecimal: placementData.supportsDecimal === 'yes',
            currencyPerUsd: placementData.currencyRate,
            capping: placementData.capping,
            pacing: placementData.pacing,
            limitation: placementData.limitation,
            apiRequest: placementData.apiRequest,
          },
          ...unit.placements.slice(placementIndex + 1),
        ],
      },
      ...app.adUnits.slice(unitIndex + 1),
    ],
  };

  let currentApp = state.app;
  if (state.app && state.app._id === appId) {
    currentApp = app;
  }

  return {
    ...state,
    apps: {
      ...state.apps,
      items: [
        ...state.apps.items.slice(0, appIndex),
        app,
        ...state.apps.items.slice(appIndex + 1),
      ],
    },
    app: currentApp,
  };
}

export function openAddStoreUrlModal(state, app) {
  return {
    ...state,
    newApp: {
      ...app,
      showModal: true,
      isFetching: false,
      error: null,
      isFetchingSuccess: true,
    },
  };
}

export function closeAddStoreUrlModal(state) {
  return {
    ...state,
    newApp: {
      showModal: false,
      isFetching: false,
      error: null,
      isFetchingSuccess: true,
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/apps.js
 **/